export function observeElementResize(element: Element, callback: () => void): () => void {
  let rafId1: number | null = null;
  let rafId2: number | null = null;

  const cancelScheduled = () => {
    if (rafId1 != null) {
      cancelAnimationFrame(rafId1);
      rafId1 = null;
    }
    if (rafId2 != null) {
      cancelAnimationFrame(rafId2);
      rafId2 = null;
    }
  };

  const schedule = () => {
    cancelScheduled();
    rafId1 = requestAnimationFrame(() => {
      rafId1 = null;
      rafId2 = requestAnimationFrame(() => {
        rafId2 = null;
        callback();
      });
    });
  };

  const observer = new ResizeObserver(schedule);
  observer.observe(element);

  return () => {
    cancelScheduled();
    observer.disconnect();
  };
}
